import { useState, useEffect } from 'react';
import { conciliarPagos } from '../../../resumenSucursal/services/mercadopago.service';
import { getPagosGeneral } from '../../services/pagosGeneral.service';
import { getObservaciones } from '../services/observaciones.service';

export const useConciliacion = (empresa, desde, hasta, triggerRecarga) => {
  const [conciliacion, setConciliacion] = useState(null);
  const [resumen, setResumen] = useState(null);
  const [metadata, setMetadata] = useState(null);
  const [observaciones, setObservaciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);

  const cargarObservaciones = async () => {
    try {
      const data = await getObservaciones(empresa);
      setObservaciones(data || []);
    } catch (error) {
      console.error('[useConciliacion] Error al cargar observaciones:', error);
    }
  };

  const cargarConciliacion = async () => {
    setCargando(true);
    setError(null);

    try {
      const pagosDB = await getPagosGeneral(empresa, desde, hasta);

      if (!pagosDB || pagosDB.length === 0) {
        setError(
          `No se encontraron pagos en la base de datos para este período (Empresa: ${empresa === 1 ? 'Hipergas' : 'Natural Gas'})`,
        );
        setCargando(false);
        return;
      }

      const response = await conciliarPagos({
        desde,
        hasta,
        pagosDB,
        empresa,
      });

      if (response.success) {
        setConciliacion(response.data);
        setResumen(response.resumen);
        setMetadata(response.metadata);
        await cargarObservaciones();
      } else {
        setError(response.error || 'Error al procesar la conciliación');
      }
    } catch (error) {
      console.error('[useConciliacion] Error:', error);
      setError(error.message || 'Error al cargar los datos de conciliación');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (desde && hasta && empresa) {
      cargarConciliacion();
    }
  }, [desde, hasta, empresa, triggerRecarga]);

  return {
    conciliacion,
    resumen,
    metadata,
    observaciones,
    cargando,
    error,
    recargar: cargarConciliacion,
    recargarObservaciones: cargarObservaciones,
  };
};